module.exports = __webpack_public_path__ + "img/charger-2.daaf78de.jpg";